module.exports = __webpack_public_path__ + "assets/img/31@3x.a5a51304.png";